import axios, { AxiosError } from 'axios';
import { clearAuthToken, getAuthToken } from './auth';
import { getCommonDefaultLanguage } from './cookies';
import { DEFAULT_LANGUAGE } from './locale';
export function createAxiosInstance({ appName }) {
    const axiosInstance = axios.create();
    axiosInstance.defaults.xsrfCookieName = 'csrftoken';
    axiosInstance.defaults.xsrfHeaderName = 'X-CSRFToken';
    // Add a response interceptor for auth-related errors
    axiosInstance.interceptors.response.use(
    // Do nothing with response data
    value => value, error => {
        if (error instanceof AxiosError && error.response?.status === 401) {
            if (getAuthToken(appName)) {
                clearAuthToken(appName);
            }
        }
        throw error;
    });
    axiosInstance.interceptors.request.use(config => {
        const authToken = getAuthToken(appName);
        const lang = getCommonDefaultLanguage(appName, DEFAULT_LANGUAGE);
        const appVersion = window['appVersion'];
        config.headers['App-Name'] = appName;
        if (authToken) {
            config.headers.Authorization = `Token ${authToken.auth_token}`;
        }
        if (lang) {
            config.headers['Accept-Language'] = lang;
        }
        if (appVersion) {
            config.headers['App-Version'] = appVersion;
        }
        return config;
    });
    return axiosInstance;
}
